"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabaseTablesDisplayGrid = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var TablesDisplayGrid_1 = require("../sharedDisplayGrid/TablesDisplayGrid");
function DatabaseTablesDisplayGrid(props) {
    var _a = react_1.default.useContext(data_catalog_shared_1.FeatureFlagsContext), publishedConnectionsLineageEnabled = _a.publishedConnectionsLineageEnabled, labelsInMorePlacesEnabled = _a.labelsInMorePlacesEnabled;
    var siteUrls = react_1.default.useContext(data_catalog_shared_1.SiteUrlsContext);
    var cols = __spreadArray([
        (0, data_catalog_shared_1.createSelectionColumn)()
    ], (0, TablesDisplayGrid_1.columns)(siteUrls).map(function (columnFactory) { return columnFactory(props); })
        .filter(function (column) {
        if (column.name === 'virtualConnections' && !publishedConnectionsLineageEnabled) {
            return false;
        }
        if (!labelsInMorePlacesEnabled &&
            (column.name === 'label-warning' || column.name === 'label-certification')) {
            return false;
        }
        if (labelsInMorePlacesEnabled &&
            (column.name === 'warning' || column.name === 'certification')) {
            return false;
        }
        if (column.name === 'database') {
            return false;
        }
        return true;
    }), true);
    return (react_1.default.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.DatabaseTablesDisplayGrid = DatabaseTablesDisplayGrid;
//# sourceMappingURL=DatabaseTablesDisplayGrid.js.map